// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responseDiv {
  padding: 18px;
  display: flex;
  flex-direction: column;
  text-align: justify;
  background-color: #fff;
  border-bottom: 1px solid #77797b;
}

.titleLogQuestion {
  display: flex;
  align-items: center;
  background-color: #eff1f2;
  padding: 5px;
}

.iconCheck {
  padding: 3px;
  width: 30px;
  height: 30px;
  margin-right: 2px;
}

.logQuestionLabel {
  font-size: 15px;
  font-weight: 400;
  white-space: pre-line;
}

.logQuestionMessage {
  font-size: 15px;
  font-weight: 400;
  word-wrap: break-word;
  white-space: pre-line;
}

.containerQuestion {
  display: flex;
  flex-direction: column;
  max-width: 550px;
  width: 100%;
  padding: 0 0 10px 35px;
  text-align: justify;
  margin-right: 50px;
}

.QuestionContainer {
  display: flex;
  flex-direction: column;
  padding: 0 35px 10px 42px;
  text-align: justify;
  background-color: #eff1f2;
  position: relative;
}

.containerQuestions {
  width: 100%;
  max-width: 1500px;
  display: flex;
  justify-content: space-between;
}

@media (min-width: 1500px) {
  .containerQuestions {
    width: 100%;
    max-width: inherit;
  }
}

.containerPlus {
  display: flex;
  justify-content: flex-end;
}

.plus {
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  background-color: #eff1f2;
  padding: 15px 42px;
}

.textPlus {
  font-size: 15px;
  color: #007bc0;
  text-decoration: underline;
  cursor: pointer;
  padding: 10px;
}

.containerMaterial .textPlus {
  padding: 5px;
}

.containerMaterial .containerPlus {
  margin-top: -5px;
}

.textPlus:hover {
  background-color: #d1e4ff;
}

.numberQuestion {
  font-size: 16px;
  font-weight: 700;
}

.iconCheckButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

@media (max-width: 1000px) {
  .containerQuestions {
    display: flex;
    flex-direction: column;
  }

  .responseQuestions {
    width: 90%;
    max-width: 1500px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding-left: 3.5ch;
  }

  .responseDiv {
    box-sizing: border-box;
    margin-bottom: 10px;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentes/logOfQuestions/log.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;AACF","sourcesContent":[".responseDiv {\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  text-align: justify;\n  background-color: #fff;\n  border-bottom: 1px solid #77797b;\n}\n\n.titleLogQuestion {\n  display: flex;\n  align-items: center;\n  background-color: #eff1f2;\n  padding: 5px;\n}\n\n.iconCheck {\n  padding: 3px;\n  width: 30px;\n  height: 30px;\n  margin-right: 2px;\n}\n\n.logQuestionLabel {\n  font-size: 15px;\n  font-weight: 400;\n  white-space: pre-line;\n}\n\n.logQuestionMessage {\n  font-size: 15px;\n  font-weight: 400;\n  word-wrap: break-word;\n  white-space: pre-line;\n}\n\n.containerQuestion {\n  display: flex;\n  flex-direction: column;\n  max-width: 550px;\n  width: 100%;\n  padding: 0 0 10px 35px;\n  text-align: justify;\n  margin-right: 50px;\n}\n\n.QuestionContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 0 35px 10px 42px;\n  text-align: justify;\n  background-color: #eff1f2;\n  position: relative;\n}\n\n.containerQuestions {\n  width: 100%;\n  max-width: 1500px;\n  display: flex;\n  justify-content: space-between;\n}\n\n@media (min-width: 1500px) {\n  .containerQuestions {\n    width: 100%;\n    max-width: inherit;\n  }\n}\n\n.containerPlus {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.plus {\n  display: flex;\n  flex-direction: row;\n  margin-top: 8px;\n  background-color: #eff1f2;\n  padding: 15px 42px;\n}\n\n.textPlus {\n  font-size: 15px;\n  color: #007bc0;\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 10px;\n}\n\n.containerMaterial .textPlus {\n  padding: 5px;\n}\n\n.containerMaterial .containerPlus {\n  margin-top: -5px;\n}\n\n.textPlus:hover {\n  background-color: #d1e4ff;\n}\n\n.numberQuestion {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.iconCheckButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n@media (max-width: 1000px) {\n  .containerQuestions {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .responseQuestions {\n    width: 90%;\n    max-width: 1500px;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    padding-left: 3.5ch;\n  }\n\n  .responseDiv {\n    box-sizing: border-box;\n    margin-bottom: 10px;\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
